/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {ForecastState} from '../bioplanModels';
/**
 * PlanningForecastStateApi - axios parameter creator
 * @export
 */
export const PlanningForecastStateApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {string} cageId
     * @param {string} date
     * @param {boolean} useDateAsStarvationTrigger
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastStateGet: async (
      cageId: string,
      date: string,
      useDateAsStarvationTrigger: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('forecastStateGet', 'cageId', cageId);
      // verify required parameter 'date' is not null or undefined
      assertParamExists('forecastStateGet', 'date', date);
      // verify required parameter 'useDateAsStarvationTrigger' is not null or undefined
      assertParamExists('forecastStateGet', 'useDateAsStarvationTrigger', useDateAsStarvationTrigger);
      const localVarPath = `/forecastState`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      if (useDateAsStarvationTrigger !== undefined) {
        localVarQueryParameter['useDateAsStarvationTrigger'] = useDateAsStarvationTrigger;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningForecastStateApi - functional programming interface
 * @export
 */
export const PlanningForecastStateApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningForecastStateApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {string} cageId
     * @param {string} date
     * @param {boolean} useDateAsStarvationTrigger
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forecastStateGet(
      cageId: string,
      date: string,
      useDateAsStarvationTrigger: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForecastState>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forecastStateGet(
        cageId,
        date,
        useDateAsStarvationTrigger,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningForecastStateApi.forecastStateGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningForecastStateApi - factory interface
 * @export
 */
export const PlanningForecastStateApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningForecastStateApiFp(configuration);
  return {
    /**
     *
     * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
     * @param {PlanningForecastStateApiForecastStateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forecastStateGet(
      requestParameters: PlanningForecastStateApiForecastStateGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ForecastState> {
      return localVarFp
        .forecastStateGet(
          requestParameters.cageId,
          requestParameters.date,
          requestParameters.useDateAsStarvationTrigger,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for forecastStateGet operation in PlanningForecastStateApi.
 * @export
 * @interface PlanningForecastStateApiForecastStateGetRequest
 */
export interface PlanningForecastStateApiForecastStateGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningForecastStateApiForecastStateGet
   */
  readonly cageId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningForecastStateApiForecastStateGet
   */
  readonly date: string;

  /**
   *
   * @type {boolean}
   * @memberof PlanningForecastStateApiForecastStateGet
   */
  readonly useDateAsStarvationTrigger: boolean;
}

/**
 * PlanningForecastStateApi - object-oriented interface
 * @export
 * @class PlanningForecastStateApi
 * @extends {BaseAPI}
 */
export class PlanningForecastStateApi extends BaseAPI {
  /**
   *
   * @summary Forecast count, weight, and/or biomass data for cages, sites, and plans.
   * @param {PlanningForecastStateApiForecastStateGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningForecastStateApi
   */
  public forecastStateGet(
    requestParameters: PlanningForecastStateApiForecastStateGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningForecastStateApiFp(this.configuration)
      .forecastStateGet(
        requestParameters.cageId,
        requestParameters.date,
        requestParameters.useDateAsStarvationTrigger,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
